import axios from 'axios';
const url = window.location.href;
const arr = url.split("/");
const result = arr[0] + "//" + arr[2];
class Api {
  install(Vue) {
    Vue.prototype.$api = this;
    this._api = axios.create({
      crossDomain: true,
      headers: {
        'accept': 'application/json',
        'accept-language': 'en_US'
      },
      baseURL: result + '/wp-json/',
      timeout: 100000,
    });
  }

  wipeGenPages() {
    return new Promise((resolve, reject) => {
      this._api.get(`remcon/v1/generator/wipe`
      ).then(function (response) {
        resolve(true);
      }).catch(function (error) {
        reject(false);
      });
    });
  }

  createAsking(data) {
    return new Promise((resolve, reject) => {
      this._api.post(`remcon/v1/askings`, data
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchGeneratorPreviews(data) {
    return new Promise((resolve, reject) => {
      this._api.get(`remcon/v1/generator/canvas?ids=${data}`,
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  createGeneratorProject(data) {
    return new Promise((resolve, reject) => {
      this._api.post(`remcon/v1/generator/add`, data
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchPages () {
    return new Promise((resolve, reject)  => {
      this._api.get(`wp/v2/pages`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchPageById (page) {
    return new Promise((resolve, reject)  => {
      this._api.get(`wp/v2/pages/${page}`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchPage (page) {
    return new Promise((resolve, reject)  => {
      this._api.get(`wp/v2/pages${page}`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchTruePage (page) {
    let trueQuery = axios.create({
      crossDomain: true,
      headers: {
        'accept': 'application/json',
        'accept-language': 'en_US'
      },
      baseURL: result,
      timeout: 10000,
    });
    return new Promise((resolve, reject)  => {
      trueQuery.get(`${page}`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchFields (page) {
    return new Promise((resolve, reject)  => {
      this._api.get(`acf/v3/pages/${page}`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchPost (post) {
    return new Promise((resolve, reject)  => {
      this._api.get(`wp/v2/posts/${post}`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchPostBySlug (post) {
    return new Promise((resolve, reject)  => {
      this._api.get(`wp/v2/posts?slug=${post}`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchCategories () {
    return new Promise((resolve, reject)  => {
      this._api.get(`wp/v2/categories/`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchPosts (page) {
    return new Promise((resolve, reject)  => {
      this._api.get(`wp/v2/posts?page=${page}`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchMedia (id, size) {
    return new Promise((resolve, reject)  => {
      this._api.get(`wp/v2/media/${id}`
      ).then(function (response) {
        resolve(response.data.media_details.sizes[size]);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchSidebar () {
    return new Promise((resolve, reject)  => {
      this._api.get(`remcon/v1/sidebar`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response);
      });
    });
  }

  fetchEvents () {
    return new Promise((resolve, reject)  => {
      this._api.get('remcon/v1/events'
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchCountries () {
    return new Promise((resolve, reject)  => {
      this._api.get('remcon/v1/countries'
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchGallery (id) {
    return new Promise((resolve, reject)  => {
      this._api.get(`gallery_plugin/v1/post/${id}`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchCart () {
    const that = this;
    return new Promise((resolve, reject)  => {
      this._api.get('wc/v2/cart'
      ).then(function (cartData) {
        // console.log()
        resolve(new Promise((resolve, reject) => {
          that._api.get('remcon/v1/coupon'
            ).then(function (response) {
              cartData.data["coupons"] = response.data.data;
              resolve(cartData.data);
            }).catch(function (error) {
              reject(error);
            });
          })
        );
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchCheckout (from) {
    let url = 'remcon/v1/checkout';
    if (from !== null) {
      url += '?country=' + from;
    }
    return new Promise((resolve, reject)  => {
      this._api.get(url
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchCheckoutPrzelewy24 (id) {
    return new Promise((resolve, reject)  => {
      this._api.get(`remcon/v1/checkout/przelewy24?id=${id}`
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  cartCalculate () {
    return new Promise((resolve, reject)  => {
      this._api.post('wc/v2/cart/calculate'
      ).then(function (response) {
        resolve(true);
      }).catch(function (error) {
        reject(error);
      });
    });
  }

  fetchCartTotal () {
    return new Promise((resolve, reject)  => {
      this._api.get('wc/v2/cart/totals'
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  addToCart (data) {
    return new Promise((resolve, reject)  => {
      this._api.post('wc/v2/cart/add', data
      ).then(function (response) {
        resolve(true);
      }).catch(function (error) {
        reject(false);
      });
    });
  }

  updateCart (data) {
    return new Promise((resolve, reject)  => {
      this._api.post('wc/v2/cart/cart-item', data
      ).then(function (response) {
        resolve(true);
      }).catch(function (error) {
        reject(false);
      });
    });
  }

  removeFromCart (data) {
    return new Promise((resolve, reject)  => {
      this._api.delete('wc/v2/cart/cart-item', {data: data}
      ).then(function (response) {
        resolve(true);
      }).catch(function (error) {
        reject(false);
      });
    });
  }

  clearCart () {
    return new Promise((resolve, reject)  => {
      this._api.post('wc/v2/cart/clear',
      ).then(function (response) {
        resolve(true);
      }).catch(function (error) {
        reject(false);
      });
    });
  }

  applyCoupon (data) {
    return new Promise((resolve, reject)  => {
      this._api.post('remcon/v1/coupon', data
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  removeCoupon (data) {
    return new Promise((resolve, reject)  => {
      this._api.delete('remcon/v1/coupon', {data: data}
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  calculateShipping () {
    return new Promise((resolve, reject)  => {
      this._api.get('remcon/v1/shippings/calculate',
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchShipping (data) {
    return new Promise((resolve, reject)  => {
      this._api
        .get(`remcon/v1/shippings?country=${data.country}&city=${data.city}&postcode=${data.postcode}`)
        .then(function(response) {
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error.response.data);
        });
    });
  }

  updateShipping (data) {
    return new Promise((resolve, reject)  => {
      this._api.post('remcon/v1/shippings/update', data
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  sendContactForm (data) {
    return new Promise((resolve, reject)  => {
      this._api.post('remcon/v1/contact/send', data
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  sendBoxesForm (data) {
    return new Promise((resolve, reject)  => {
      this._api.post('remcon/v1/boxes/send', data
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchPaymentData (data) {
    return new Promise((resolve, reject)  => {
      this._api.post('remcon/v1/payment', data
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  updateOrder (data) {
    return new Promise((resolve, reject)  => {
      this._api.put('remcon/v1/order', data
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchGeneratorData () {
    return new Promise((resolve, reject)  => {
      this._api.get('remcon/v1/generator?queryVek=true',
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  fetchGeneratorLayout (id) {
    return new Promise((resolve, reject)  => {
      this._api.get(`remcon/v1/generator/project/?id=${id}`,
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }
}

export default Api;
